import { propertyTypeService } from '@/services/api/propertyType.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { propertyTypeModel } from '@/models/api/propertyType.model';
import { propertyTypeStatisticSummaryModel } from '@/models/api/propertyTypeStatisticSummary.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    statisticSummary: [],
    status: {
        list: true,
        detail: true,
        save: true,
        statisticSummary: true,
    },
};

export const PROPERTY_TYPE_MODULE = "api/propertyType";

// ACTIONS
export const GET_PROPERTY_TYPE_STATISTIC_SUMMARY = 'getPropertyTypeStatisticSummary';
export const GET_ALL_PROPERTY_TYPE = 'getAllPropertyType';
export const CREATE_PROPERTY_TYPE = 'createPropertyType';
export const GET_PROPERTY_TYPE = 'getPropertyType';
export const UPDATE_PROPERTY_TYPE = 'updatePropertyType';
export const UPDATE_PROPERTY_TYPE_STATUS = 'updatePropertyTypeStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PROPERTY_TYPE_SUCCESS = "allPropertyTypeSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PROPERTY_TYPE_SUCCESS = "getPropertyTypeSuccess";

const PROPERTY_TYPE_STATISTIC_SUMMARY_SUCCESS = "propertyTypeStatisticSummarySuccess";

export const actions = {
    [GET_PROPERTY_TYPE_STATISTIC_SUMMARY]({commit}) {
        commit(REQUESTING, 'statisticSummary');
        return propertyTypeService
            .statisticSummary()
            .then((result) => {
                commit(PROPERTY_TYPE_STATISTIC_SUMMARY_SUCCESS, result);
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },

    [GET_ALL_PROPERTY_TYPE]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        propertyTypeService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PROPERTY_TYPE_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_PROPERTY_TYPE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyTypeService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_TYPE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PROPERTY_TYPE]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return propertyTypeService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PROPERTY_TYPE_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PROPERTY_TYPE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyTypeService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_TYPE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PROPERTY_TYPE_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return propertyTypeService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_TYPE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [PROPERTY_TYPE_STATISTIC_SUMMARY_SUCCESS](state, data) {
        state.statisticSummary = data.success ? (data.data || []).map(item => propertyTypeStatisticSummaryModel(item)) : [];
    },
    [ALL_PROPERTY_TYPE_SUCCESS](state, {data}) {
        let propertyTypeList = data.data || [];
        state.list.data = propertyTypeList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = propertyTypeList.map(item => propertyTypeModel(item));
        }
    },
    [GET_PROPERTY_TYPE_SUCCESS](state, data) {
        state.details = propertyTypeModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        statisticSummary: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        statisticSummary: true,
        };
    },
};
